import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

export const useProfileComplete = () => {
  const { user } = useAuth();
  const [isComplete, setIsComplete] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setLoading(false);
      setIsComplete(null);
      return;
    }

    const check = async () => {
      const { data, error } = await supabase
        .from("profiles")
        .select("display_name, phone_number, phone_numbers")
        .eq("user_id", user.id)
        .maybeSingle();

      if (error || !data) {
        setIsComplete(false);
      } else {
        const hasPhones = Array.isArray((data as any).phone_numbers) && (data as any).phone_numbers.length > 0;
        setIsComplete(
          !!data.display_name?.trim() &&
          (hasPhones || !!data.phone_number?.trim())
        );
      }
      setLoading(false);
    };

    check();
  }, [user]);

  return { isComplete, loading };
};
